import { Record } from 'immutable';

export const Err = Record({
  requestId: 0,
  errorCode: 'general',
  errorMessage: 'An error has occurred.'
});

export function handleError(error) {
  // If error.message exists we can assume this is a javascript exception. not a result error from the portal api.
  if(error.message) {
    console.error(error);
    return new Err({
      errorCode: 'exception',
      errorMessage: error.message
    });
  }
  else {
    console.error(`RequestId: ${error.requestId}. Error: ${error.errorMessage}`);
    return new Err(error);
  }
}
